import type { QuoteBlock } from './QuoteTypes'

/**
 * QuoteMargin — individual and global margin helpers.
 */
export class QuoteMargin {
  fromPurchase(purchasePrice: number, marginPercent: number): number {
    if (marginPercent >= 100) return round2(purchasePrice * 2)
    if (marginPercent <= 0) return round2(purchasePrice)
    return round2(purchasePrice / (1 - marginPercent / 100))
  }

  percent(purchasePrice: number, salePrice: number): number {
    if (salePrice <= 0) return 0
    return round2(((salePrice - purchasePrice) / salePrice) * 100)
  }

  profit(purchasePrice: number, salePrice: number, quantity = 1): number {
    return round2((salePrice - purchasePrice) * quantity)
  }

  applyGlobalMargin(blocks: QuoteBlock[], globalMarginPercent: number): QuoteBlock[] {
    return blocks.map((block) => {
      if (!isPricedBlock(block)) return block
      const salePrice = this.fromPurchase(block.purchasePrice, globalMarginPercent)
      return {
        ...block,
        salePrice,
        margin: globalMarginPercent,
        profit: this.profit(block.purchasePrice, salePrice, block.quantity),
      }
    })
  }
}

function isPricedBlock(block: QuoteBlock): boolean {
  return block.type === 'product' || block.type === 'service' || block.type === 'labor'
}

function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100
}

export const quoteMargin = new QuoteMargin()
